import { render, staticRenderFns } from "./SaleDocumentation.vue?vue&type=template&id=7aa4cc5c&scoped=true&"
import script from "./SaleDocumentation.vue?vue&type=script&lang=js&"
export * from "./SaleDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./SaleDocumentation.vue?vue&type=style&index=0&id=7aa4cc5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa4cc5c",
  null
  
)

export default component.exports